import { render, staticRenderFns } from "./AnnotationWorkStatisticsItem.vue?vue&type=template&id=9d8f5140&"
import script from "./AnnotationWorkStatisticsItem.vue?vue&type=script&lang=js&"
export * from "./AnnotationWorkStatisticsItem.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationWorkStatisticsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports